module.exports = __webpack_public_path__ + "media/images/no_map_fallback-0d2eb4e1.png";